import { api, ApiError, isTerminalRefreshDenial } from '../api/client';
import type { Session } from '../api/types';

/** Retry only the harmless session GET once; an unknown refresh POST never retries. */
async function readSession(): Promise<Session> {
  for (let attempt = 0; ; attempt++) {
    try {
      return await api<Session>('/auth/session');
    } catch (error) {
      const transportFailure = error instanceof TypeError ||
        (error instanceof ApiError && error.status === 0 && error.code === 'request_timeout');
      if (attempt !== 0 || !transportFailure) throw error;
      await new Promise<void>(resolve => setTimeout(resolve, 1000));
    }
  }
}

/** Read valid access; api() performs one shared refresh only after a 401. */
export async function restoreSession(): Promise<Session | null> {
  try {
    try {
      return await readSession();
    } catch (error) {
      // Compatibility with an older API during a rolling deployment.
      // A network error or 5xx must never initiate an extra refresh POST.
      if (!(error instanceof ApiError) || error.status !== 404) throw error;
      return await api<Session>('/auth/refresh', { method: 'POST', body: {} });
    }
  } catch (error) {
    if (error instanceof ApiError && isTerminalRefreshDenial(error)) return null;
    throw error;
  }
}
